import React from 'react';
import styles from './About.module.css'; // Importă fișierul CSS Modules

const About = () => {
    return (
        <div className={styles.aboutContainer}>
            <section className={styles.heroSection}>
                <div className={styles.heroContent}>
                    <h1 className={styles.heroTitle}>Despre Mine</h1>
                    <p className={styles.heroSubtitle}>
                        Senior QA Automation & Full-Stack Developer
                    </p>
                    <a
                        href='https://mariusonea.ro'
                        target='_blank'
                        rel='noopener noreferrer'
                        className={styles.heroLink}
                    >
                        Vizitează mariusonea.ro
                    </a>
                </div>
            </section>

            <section className={styles.summarySection}>
                <h2 className={styles.sectionTitle}>Rezumat Profesional</h2>
                <p className={styles.summaryText}>
                    Analist de Testare Software cu o bază solidă în asigurarea calității 
                    aplicațiilor, activând în prezent în cadrul Capgemini. Expertiza 
                    principală se concentrează pe testarea API-urilor (Postman) și 
                    automatizarea proceselor de testare (Selenium, Java, BDD, Cucumber, Gherkin). 
                    Capacitatea de analiză a sistemelor complexe este dublată de o experiență 
                    anterioară relevantă în telecomunicații și de studiul aprofundat al 
                    rețelisticii (CompTIA Network+ N10-009), domeniu care a consolidat 
                    înțelegerea protocoalelor de comunicare și a arhitecturilor de rețea.
                </p>
                <p className={styles.summaryText}>
                    Portofoliul meu de competențe include optimizarea fluxurilor API prin 
                    Apigee X și pregătirea tehnică pentru arhitecturi de integrare 
                    utilizând MuleSoft 4.X. În paralel cu activitatea de QA, capabilitățile 
                    de dezvoltare Full-Stack sunt demonstrate prin ingineria unor proiecte 
                    independente complexe, bazate pe stiva MERN (INKoMOD, PackSense Academy). 
                    Pasionat de arhitectura software, pun accent pe crearea de soluții digitale 
                    scalabile, dezvoltarea de motoare logice personalizate și integrarea AI 
                    pentru eficientizarea proceselor.
                </p>
            </section>

            <section className={styles.skillsSection}>
                <h2 className={styles.sectionTitle}>Abilități Cheie</h2>
                <div className={styles.skillsGrid}>
                    <div className={styles.skillCategory}>
                        <h3>Testare Software & QA</h3>
                        <ul className={styles.skillsList}>
                            <li>ISTQB® Foundation Level</li>
                            <li>Testare Automată & Manuală</li>
                            <li>Java, Selenium WebDriver</li>
                            <li>Cucumber, Gherkin, BDD</li>
                            <li>Testare API (Postman)</li>
                            <li>Data Validation</li>
                        </ul>
                    </div>
                    <div className={styles.skillCategory}>
                        <h3>Dezvoltare & API</h3>
                        <ul className={styles.skillsList}>
                            <li>MongoDB, Express, React, Node.js</li>
                            <li>JavaScript (Avansat) </li>
							<li>TypeScript, Vite</li>
                            <li>Apigee X (Proxy Development)</li>
                            <li>MuleSoft 4.X (Integrare Sisteme)</li>
                            <li>REST / SOAP APIs</li>
                            <li>HTML5, CSS3/SASS, UX/UI</li>
                        </ul>
                    </div>
                    <div className={styles.skillCategory}>
                        <h3>Arhitectură & Concepte</h3>
                        <ul className={styles.skillsList}>
                            <li>Inginerie Software & Design Algoritmi</li>
                            <li>State Management (Redux/Context)</li>
                            <li>Integrare AI (Gemini)</li>
                            <li>Rețelistică (CompTIA Network+)</li>
                            <li>Metodologii Agile (Scrum/Kanban)</li>
                            <li>Git, Docker (baze), AWS Cloud</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className={styles.experienceSection}>
                <h2 className={styles.sectionTitle}>Experiență Profesională</h2>
                <div className={styles.timeline}>
                    <div className={styles.timelineItem}>
                        <h3 className={styles.experienceTitle}>
                            Analist Testare Software & Dezvoltator Proxy API
                        </h3>
                        <p className={styles.experienceCompany}>
                            Capgemini | mart. 2022 - Prezent
                        </p>
                        <p className={styles.experienceDescription}>
                            Executarea proceselor de testare manuală și automată folosind framework-uri 
                            bazate pe Java, Selenium și BDD. Administrarea ciclului de viață complet 
                            al proxy-urilor API prin platforma Apigee X și extinderea capacităților 
                            arhitecturale de integrare utilizând soluții bazate pe MuleSoft (4.X).
                        </p>
                    </div>
                    <div className={styles.timelineItem}>
                        <h3 className={styles.experienceTitle}>
                            Web Developer / Full-Stack Engineer
                        </h3>
                        <p className={styles.experienceCompany}>
                            Lucrător independent | sept. 2021 - Prezent
                        </p>
                        <p className={styles.experienceDescription}>
                            Gestionarea ciclului complet de dezvoltare software. Arhitectarea 
                            INKoMOD (joc RPG Text-Based cu arhitectură Client-Server și motoare 
                            logice customizate) și dezvoltarea platformelor de producție 
                            precum PackSense Academy (stiva MERN, CMS securizat, RBAC). Utilizarea 
                            AI pentru optimizarea și accelerarea dezvoltării de module.
                        </p>
                    </div>
                    <div className={styles.timelineItem}>
                        <h3 className={styles.experienceTitle}>
                            Retention Specialist
                        </h3>
                        <p className={styles.experienceCompany}>
                            Vodafone | apr. 2013 - sept. 2021
                        </p>
                        <p className={styles.experienceDescription}>
                            Optimizarea continuă a proceselor departamentale și dezvoltarea 
                            de instrumente interne care au eficientizat fluxurile de lucru. 
                            Gestionarea negocierilor complexe și acordarea de mentorat tehnic 
                            pentru integrarea noilor angajați.
                        </p>
                    </div>
                </div>
            </section>

            <section className={styles.educationSection}>
                <h2 className={styles.sectionTitle}>Educație & Certificări</h2>
                
                <div className={styles.educationItem}>
                    <h3 className={styles.educationTitle}>
                        Academia de Studii Economice din București
                    </h3>
                    <p className={styles.educationDetails}>
                        Licență, Management | sept. 2010 - iun. 2013
                    </p>
                    <p className={styles.educationDescription}>
                        Specializare în Managementul Investițiilor (Media 9) și analiză strategică organizațională.
                    </p>
                </div>
                
                <div className={styles.educationItem}>
                    <h3 className={styles.educationTitle}>
                        Colegiul Spiru Haret Ploiești
                    </h3>
                    <p className={styles.educationDetails}>
                        Liceu Mate-Info, Profil Real | sept. 2006 - iun. 2010
                    </p>
                    <p className={styles.educationDescription}>
                        Profil intensiv Informatică; baze solide în algoritmi și programare (C++, HTML, CSS).
                    </p>
                </div>

                <div className={styles.certifications}>
                    <h3 className={styles.certificationTitle}>Licențe și Certificări</h3>
                    <ul className={styles.certificationsList}>
                        <li>CompTIA Network+ (N10-009) Crash Course (Udemy, 2025)</li>
                        <li>AWS Certified Cloud Practitioner (Amazon Web Services, 2022)</li>
                        <li>The Complete Java Development Bootcamp (Udemy, 2022)</li>
                        <li>ISTQB® Certified Tester, Foundation Level (ISTQB, 2022)</li>
                        <li>MERN Fullstack Developer (Udemy, 2022)</li>
                        <li>JavaScript - Advanced & React JS (Udemy, 2021)</li>
                        <li>Front End Developer (Bittnet Training, 2021)</li>
                    </ul>
                </div>
            </section>
        </div>
    );
};

export default About;